import { render, staticRenderFns } from "./PermissionsReport.vue?vue&type=template&id=0652a39b&scoped=true"
import script from "./PermissionsReport.vue?vue&type=script&lang=js"
export * from "./PermissionsReport.vue?vue&type=script&lang=js"
import style0 from "./PermissionsReport.vue?vue&type=style&index=0&id=0652a39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652a39b",
  null
  
)

export default component.exports